import { Space, Tag } from "antd";
import { useDispatch } from "react-redux";
import {
  centroCostoSetActive,
  centroCostoStartDelete,
} from "../../../actions/empresa";
import { showDeleteConfirm } from "../../../helpers/confirmModal";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { TableUi } from "../../ui/TableUi";
import { EditDetailBtn, RemoveDetailBtn } from "../../ui";
import { TableSearchBasicUi } from "../../ui/TableSearchBasicUi";

const columns = (acciones) => [
  {
    title: "N°",
    dataIndex: "index",
    key: "index",
    render: (text, record, index) => <>{index + 1}</>,
  },
  {
    title: "Código",
    dataIndex: "codigo",
    key: "codigo",
  },
  {
    title: "Nombre",
    dataIndex: "nombre",
    key: "nombre",
  },
  {
    title: "Estado",
    dataIndex: "state",
    key: "state",
    render: (text, record) =>
      text === true ? (
        <Tag color="green">Activo</Tag>
      ) : (
        <Tag color="red">Inactivo</Tag>
      ),
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    render: (text, record) => (
      <Space size="middle">
        <EditDetailBtn onClick={() => acciones.handleEditar(record)} />
        <RemoveDetailBtn onClick={() => acciones.handleEliminar(record)} />
      </Space>
    ),
  },
];
export const CentroCostosTable = ({ data, loading, onOpenModal }) => {
  const dispatch = useDispatch();
  const handleEditar = (data) => {
    dispatch(centroCostoSetActive(data));
    onOpenModal();
  };
  const handleEliminar = (item) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar el centro de costo seleccionado?",
      `${item.nombre}`,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(centroCostoStartDelete(item));
        }
      },
    );
  };

  return (
    <TableSearchBasicUi
      columns={columns({ handleEditar, handleEliminar })}
      rowKey="id"
      bordered
      dataSource={data}
      loading={loading}
      size="small"
    />
  );
};
